import { Component } from '@angular/core'
import { CmsOrderDetailItemsComponent } from '@spartacus/core'
import { OrderDetailItemsComponent, OrderDetailsService } from '@spartacus/order/components'
import { CmsComponentData } from '@spartacus/storefront'
import { SharedService } from '../../../../services/shared/shared.service'
import { CustomOrderHistoryService } from '../../../../services/order/custom-order-history.service'

@Component({
    selector: 'app-custom-order-details-items',
    templateUrl: './custom-order-details-items.component.html',
    styleUrls: ['./custom-order-details-items.component.scss'],
    standalone: false
})
export class CustomOrderDetailsItemsComponent extends OrderDetailItemsComponent {
  constructor(
    protected orderDetailsService: OrderDetailsService,
    protected component: CmsComponentData<CmsOrderDetailItemsComponent>,
    public sharedService: SharedService,
    public customOrderHistoryService: CustomOrderHistoryService
  ) {
    super(orderDetailsService, component)
  }
}
